export const getDaysLeftInMonth = () => {
  const today = new Date();
  const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  return Math.max(0, lastDayOfMonth.getDate() - today.getDate());
};
